import { CrawlerType } from '../../models/integration/crawler';

/**
 * Steps of the single-crawler stepper
 * - DISCOVERY integrations:  discover URLs first, then crawl them, then analyze.
 * - SINGLE_URL / EXCEL_BATCH integrations: skip straight to crawl step.
 */

export enum IntegrationRunStepKey {
  DISCOVERY = 'discovery',
  CRAWL = 'crawl',
  ANALYZE = 'analyze',
}

export enum IntegrationRunStepStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed'
}

export interface IntegrationRunStep {
  key: IntegrationRunStepKey;
  labelKey: string;
  status: IntegrationRunStepStatus;
  // whether the step is accessible or not: previous steps must be completed
  // (e.g. discovery to access the crawl step)
  selectable: boolean;
}

export const STEPS_BY_CRAWLER_TYPE: Record<CrawlerType, IntegrationRunStepKey[]> = {
  [CrawlerType.DISCOVERY]: [
    IntegrationRunStepKey.DISCOVERY,
    IntegrationRunStepKey.CRAWL,
    IntegrationRunStepKey.ANALYZE,
  ],
  [CrawlerType.SINGLE_URL]: [
    IntegrationRunStepKey.CRAWL,
    IntegrationRunStepKey.ANALYZE,
  ],
  [CrawlerType.EXCEL_BATCH]: [
    IntegrationRunStepKey.CRAWL,
    IntegrationRunStepKey.ANALYZE,
  ],
};

export const STEP_LABEL_KEYS: Record<IntegrationRunStepKey, string> = {
  [IntegrationRunStepKey.DISCOVERY]: 'INTEGRATIONS.STEPS.DISCOVERY',
  [IntegrationRunStepKey.CRAWL]: 'INTEGRATIONS.STEPS.CRAWL',
  [IntegrationRunStepKey.ANALYZE]: 'INTEGRATIONS.STEPS.ANALYZE',
};
